import { CBreadcrumb, CBreadcrumbItem } from '@coreui/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, matchPath, useLocation } from 'react-router-dom';

import { getRoutes } from '../../../navigation/routeConfig';

const getPaths = function getPaths(pathname: string) {
  const paths = ['/'];
  if (pathname === '/') {
    return paths;
  }

  pathname.split('/').reduce(function (prev: any, curr: any) {
    const currPath = ''.concat(prev, '/').concat(curr);
    paths.push(currPath);
    return currPath;
  });
  return paths;
};

export const Breadcrumbs = () => {
  const [matchedRoutes, setMatchedRoutes] = useState<any>([]);
  const { t } = useTranslation();
  const currentPath = useLocation().pathname;
  const currentPathLevels = getPaths(currentPath);

  useEffect(() => {
    const matchedRoutes = currentPathLevels
      .map(pathLevel => {
        const matches = getRoutes()
          .map(config => {
            const match = matchPath(pathLevel, {
              path: config.path,
              exact: config.exact,
            });

            if (match) {
              return { ...match, ...config };
            } else {
              return null;
            }
          })
          .filter(match => match && match.name)
          .map(async match => {
            return {
              ...match,
              name: typeof match?.name === 'function' ? await match?.name(match.params) : t(`routes.${match?.name}`),
            };
          });
        return matches;
      })
      .flat();

    Promise.all(matchedRoutes)
      .then(results => {
        setMatchedRoutes(results);
      })
      .catch((e: any) => {
        console.warn('Error', e);
      });
  // eslint-disable-next-line
  }, [currentPath]);

  return (
    <CBreadcrumb className="border-0 c-subheader-nav m-0 px-0 px-md-3">
      {matchedRoutes.map((route: any, index: number) => (
        index === matchedRoutes.length - 1
          ? <CBreadcrumbItem active key={index}>{route?.name}</CBreadcrumbItem>
          : <CBreadcrumbItem key={index}><Link to={route?.url}>{route?.name}</Link></CBreadcrumbItem>
      ))}
    </CBreadcrumb>
  );
};
